import { Paper, Box } from "@mui/material";
import React, { forwardRef, useImperativeHandle } from "react";
import FormSectionBuilder from "./form_section_builder";

const DataFormComponent = forwardRef(({ dataForm }, ref) => {
  function preprocessDataForm() {
    const dForm = document.querySelector(`#dataForm`);
    const formData = new FormData(dForm);
    const values = Object.fromEntries(formData.entries());

    let exludedName = "";
    let excluded = false;

    dataForm.form.form.sections.every((section) => {
      const ex = section.fields.every((field) => {
        if (!field.is_optional) {
          if (
            !formData.has(field.reference) ||
            values[field.reference]?.length <= 0
          ) {
            excluded = true;
            exludedName = `${field.display_name} (${section.title})`;
            return false;
          }
        }
        return true;
      });

      return ex;
    });

    if (excluded === true) {
      return { error: `${exludedName} is not provided.` };
    }

    return { values };
  }

  function handleSubmit() {
    if (dataForm === null) {
      return {
        error: "Data form not initialized. Select a campaign to proceed.",
      };
    }

    return preprocessDataForm();
  }

  useImperativeHandle(ref, () => ({
    submit: handleSubmit,
  }));

  return (
    <Box>
      {dataForm !== null && (
        <form id="dataForm">
          <Box>
            {dataForm.form.form.sections.map((formSection) => {
              let sect = <></>;
              if (
                formSection.reference in
                dataForm.form.form.navigation_logic.listeners
              ) {
                const listener =
                  dataForm.form.form.navigation_logic.listeners[
                    formSection.reference
                  ];
                const wID = `t_watcher_${listener.type}_${formSection.reference}`;
                sect = (
                  <div id={`${wID}`} style={{ display: "none" }}>
                    <Box mt={5} mb={3}>
                      <Paper elevation={3}>
                        <Box px={3} py={3}>
                          <FormSectionBuilder
                            section={formSection}
                            logic={dataForm.form.form.navigation_logic}
                          />
                        </Box>
                      </Paper>
                    </Box>
                  </div>
                );
                setTimeout(async () => {
                  const parentField = document.getElementById(
                    `dff_${listener.trigger}`,
                  );
                  parentField.addEventListener("change", function () {
                    const d = document.getElementById(wID);
                    if (parentField.value !== listener.control) {
                      d.style.display = "none";
                      formSection.fields.every((fld) => {
                        document.getElementById(`dff_${fld.reference}`).value =
                          null;
                        return false;
                      });
                    } else {
                      d.style.display = "block";
                    }
                  });
                }, 1000);
              } else {
                sect = (
                  <Box mt={5} mb={3}>
                    <Paper elevation={3}>
                      <Box px={3} py={3}>
                        <FormSectionBuilder
                          section={formSection}
                          logic={dataForm.form.form.navigation_logic}
                        />
                      </Box>
                    </Paper>
                  </Box>
                );
              }
              return sect;
            })}
          </Box>
        </form>
      )}
    </Box>
  );
});

export default DataFormComponent;
